module.exports = " <bh-header logo=http://res.wisedu.com/scenes/public/images/demo/logo.png slogon=\"jqwidget-based Vue Components\" :has-sidemenu=true :nav-items=navItems :side-menus=sideMenus :icons=icons :user-info=userInfo> </bh-header> <main> <router-view></router-view> </main> <bh-footer copyright=\"版权信息：© 2015 江苏金智教育信息股份有限公司 苏ICP备10204514号\"></bh-footer> <div id=message_success></div> <div id=message_error></div> <div id=jqxLoader style=display:none></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.5.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 228
// module chunks = 36